<script setup>
defineProps({
  active: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  variant: {
    type: String
  },
  size: {
    type: String
  },
  button: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <component
    :is="button ? 'button' : 'div'"
    class="list-group-item"
    :class="{
      [`list-group-item-${variant}`]: variant,
      'text-left': button,
      active,
      disabled
    }"
  >
    <slot></slot>
  </component>
</template>

<style scoped lang="scss"></style>
